import type { Club } from '@court-sync/shared';
import { ClubAcademyAccessSettingsTab } from '@/components/club/ClubAcademyAccessSettingsTab';
import { ClubHoursEditor } from '@/components/club/ClubHoursEditor';

interface FacilitySettingsPanelProps {
  club: Club;
  showAcademyAccess: boolean;
  hasCourtHire?: boolean;
}

export function FacilitySettingsPanel({
  club,
  showAcademyAccess,
  hasCourtHire = true,
}: FacilitySettingsPanelProps) {
  return (
    <div className="space-y-8">
      <ClubHoursEditor club={club} hasCourtHire={hasCourtHire} />
      {showAcademyAccess ? (
        <div className="border-t border-gray-200 pt-8 dark:border-gray-700">
          <h3 className="mb-4 text-sm font-semibold text-gray-900 dark:text-white">
            Academy court access
          </h3>
          <ClubAcademyAccessSettingsTab clubId={club.id} />
        </div>
      ) : null}
    </div>
  );
}
